import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'hideFreeChoiceMessage',
  initialState: false,
  reducers: {
    setHideFreeChoiceMessage(state, action: PayloadAction<boolean>) {
      return Boolean(action.payload);
    },
  },
});

export const { setHideFreeChoiceMessage } = slice.actions;

export default slice.reducer;
